import { render, staticRenderFns } from "./AdditionalText.vue?vue&type=template&id=54506284&scoped=true&"
import script from "./AdditionalText.vue?vue&type=script&lang=ts&"
export * from "./AdditionalText.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalText.vue?vue&type=style&index=0&id=54506284&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54506284",
  null
  
)

export default component.exports